// 5 idiomas originales + oleada 2026-07-25 (RU/KO/ZH-TW/JA/TR, estudio de
// mercado del juego: Corea ~36% del revenue, Rusia demanda probada, Taiwán y
// Japón top-5, Turquía comunidad grande). Los nuevos viven en translations.extra.ts.
// El ciclo con translations.extra es solo de TIPOS en la otra dirección (se
// borra al compilar): sin ciclo en runtime.
import { ja, ko, ru, tr, zh } from './translations.extra';

export type Lang = 'en' | 'es' | 'pt' | 'fr' | 'de' | 'ru' | 'ko' | 'zh' | 'ja' | 'tr';

export interface Translations {
  nav: { products: string; how: string; pricing: string; faq: string; contact: string; enter: string };
  hero: { badge: string; tagline: string[]; cta1: string; cta2: string };
  stats: { s1l: string; s1v: string; s2l: string; s2v: string; s3l: string; s3v: string; s4l: string; s4v: string };
  products: {
    title: string; sub: string;
    downloadable: { badge: string; name: string; desc: string; features: string[]; priceNote: string; cta: string };
    cloud: { badge: string; name: string; desc: string; features: string[]; priceNote: string; notifyLabel: string; betaAccess: string };
  };
  // Beta gratuita del descargable hasta el 15/8/2026 (decisión 2026-07-20):
  // textos que sustituyen a los normales mientras dure. LandingPage comprueba
  // la fecha en runtime — el 16/8 vuelven solos los textos normales sin redeploy.
  // stepTrial sustituye a steps.items[0] (el paso del trial en los 5 idiomas).
  beta: {
    hero: { badge: string; cta1: string };
    stats: { s4v: string; s4l: string };
    stepTrial: { title: string; desc: string };
    downloadable: { badge: string; trialFeature: string; priceNote: string; cta: string };
    faq: { q: string; a: string };
  };
  cloudNotify: {
    emailPh: string; submit: string; submitting: string;
    successTitle: string; successBody: string; errorMsg: string;
  };
  forwhom: {
    yes: { title: string; items: string[] };
    no: { title: string; items: string[] };
  };
  compare: {
    title: string; sub: string;
    headers: [string, string, string];
    rows: [string, string, string][];
  };
  // Contraposicionamiento — RETIRADO del render 2026-07-24 (decisión del
  // dueño). Opcional: los idiomas de la oleada 2026-07 no lo traducen.
  vs?: {
    title: string; sub: string;
    them: { title: string; items: string[] };
    us: { title: string; items: string[] };
    cta: string;
  };
  // Captura de email de la beta (form Netlify "beta-list"); los que entran a la
  // beta ya dejan email al registrarse — esto captura a los que aún no se deciden
  betaList: {
    title: string; body: string; emailPh: string; submit: string; submitting: string;
    successTitle: string; successBody: string; errorMsg: string; supportNote: string;
  };
  benefits: { title: string; sub: string; items: { title: string; desc: string }[] };
  steps: { title: string; sub: string; items: { title: string; desc: string }[] };
  // Precios — copy MUERTO (la sección fue sustituida por el estado en vivo).
  // Opcional: los idiomas de la oleada 2026-07 no lo traducen.
  pricing?: {
    title: string; sub: string;
    downloadable: { name: string; badge: string; price: string; period: string; desc: string; features: string[]; cta: string };
    cloud: { name: string; badge: string; price: string; period: string; desc: string; features: string[]; cta: string };
    // Planes multi-cuenta (D18): beta desactivada; sin CTA de compra (soon).
    betaBadge: string; soon: string;
    farm: { name: string; price: string; period: string; tagline: string };
    farmPlus: { name: string; price: string; period: string; tagline: string };
  };
  trust: { title: string; sub: string; items: { title: string; desc: string }[] };
  risk: { title: string; p1: string; p2: string; termsLink: string };
  contact: {
    title: string; sub: string; label: string;
    fields: { name: string; email: string; subject: string; message: string };
    subjects: { consulta: string; soporte: string; facturacion: string; baneo: string; otro: string };
    submit: string; submitting: string;
    successTitle: string; successBody: string;
    errorMsg: string;
    namePh: string; emailPh: string; messagePh: string;
  };
  faq: { title: string; items: { q: string; a: string }[] };
  blog: { sectionTitle: string; sectionSub: string; readMore: string; viewAll: string };
  footer: { copy: string; links: { enter: string; faq: string; contact: string; privacy: string; terms: string; blog: string; status: string } };
  // Apartados (hosted): copy conservado para reintroducirlo cuando aplique.
  // - referral: el programa de referidos era mecánica del hosted; volverá cuando
  //   el descargable tenga referidos propios (decisión 2026-07-05).
  // - waitlist: cola automática de la beta hosted (hero at-capacity), retirada
  //   de la landing con el pivote al descargable.
  // - intelligence: copy de la función exclusiva del hosted.
  referral?: { title: string; body: string; stat1: string; stat2: string };
  waitlist?: {
    badge: string; title: string; body: string;
    emailPh: string; submit: string; submitting: string;
    successTitle: string; successBody: string;
    invitedTitle: string; invitedBody: string;
    claimedTitle: string; claimedBody: string;
    errorMsg: string; invalidEmail: string;
    haveInvite: string; ctaJoin: string; waitingCount: string;
  };
  intelligence?: Record<string, string>;
}

const en: Translations = {
  nav: { products: 'Products', how: 'How it works', pricing: 'Pricing', faq: 'FAQ', contact: 'Contact', enter: 'Log in' },
  hero: {
    badge: '5-day free trial · No commitment',
    // Hero = variante B (producto directo, protección primero). Alternativas
    // valoradas y descartadas de momento — cambiar aquí si el dueño prefiere:
    //  A (historia): "You went to sleep. Someone hit your city at 3AM." /
    //    "White Bot saw it coming — shielded your city, recalled your troops,
    //    and held the line until you woke up."
    //  C (contraposicionamiento): "Their bot farms 500 accounts in the cloud.
    //    Ours protects the one that matters — yours."
    tagline: [
      'The Whiteout Survival bot that protects your city while you sleep —',
      'Auto Shield detects attacks, shields up and recalls your troops.',
      'Runs on your own PC. Controlled from your phone.',
    ],
    cta1: 'Try free for 5 days',
    cta2: 'See how it works ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Bot working on your PC',
    s2v: '100% web', s2l: 'Control from any device',
    s3v: '0 confirmed bans', s3l: 'Among our users',
    s4v: '5 days', s4l: 'Free trial, cancel anytime',
  },
  products: {
    title: 'Choose your White Bot',
    sub: 'The same bot, two ways to run it.',
    downloadable: {
      badge: 'Available now',
      name: 'White Bot Desktop',
      desc: 'The bot runs on your PC with Windows and BlueStacks. You install it, you own it — and you control everything from the web, wherever you are.',
      features: [
        'Runs on your PC (Windows + BlueStacks)',
        'Full control from the web',
        'Gathering, troop training, hunting and Auto Shield',
        '🔍 Intelligence: 5 lookups/day included',
        '5-day free trial — no card',
      ],
      priceNote: '€11.99/month after the trial',
      cta: 'Try free for 5 days',
    },
    cloud: {
      badge: 'In development — private beta',
      name: 'White Bot Cloud',
      desc: 'We run the bot for you on our servers, 24/7, with nothing to install. Currently in private beta while we finish it.',
      features: [
        'We run it for you, 24/7',
        'Zero installs — no PC needed',
        'Full, unlimited Intelligence',
        'Limited seats',
      ],
      priceNote: 'From €49.99/month when it opens',
      notifyLabel: 'Interested? We\'ll email you when it opens:',
      betaAccess: 'Already in the private beta? Log in',
    },
  },
  cloudNotify: {
    emailPh: 'you@email.com',
    submit: 'Notify me when it opens',
    submitting: 'Sending…',
    successTitle: 'You\'re on the list!',
    successBody: 'We\'ll write to this email when White Bot Cloud opens its doors.',
    errorMsg: 'Could not send. Please try again in a moment.',
  },
  forwhom: {
    yes: {
      title: 'Perfect for you if…',
      items: [
        'You already have an established Whiteout Survival account',
        'You have a Windows PC where the bot can run',
        'You want to progress while you work, study, or sleep',
        'You want to control the bot from your phone, anywhere',
      ],
    },
    no: {
      title: 'Keep in mind…',
      items: [
        'The bot needs your PC on, with BlueStacks running, while it works',
        'White Bot does not handle tutorials or new accounts',
        'Using bots may violate the game\'s Terms of Service (see FAQ)',
        'The game must be set to English or Spanish',
      ],
    },
  },
  compare: {
    title: 'Manual vs White Bot',
    sub: 'Same actions you\'d do yourself — but 24 hours a day.',
    headers: ['', 'Playing manually', 'With White Bot'],
    rows: [
      ['Active hours', 'Only when you play', '24 h / 7 days'],
      ['Resource gathering', 'Limited to your sessions', 'Continuous and maximised'],
      ['Troop queue', 'Sometimes left empty', 'Always active'],
      ['Monster hunting', 'A few per day', 'Dozens of cycles a day'],
      ['Your time invested', '2–3 hours daily', '0 hours'],
      ['Mobile control', 'The game app only', 'Full panel in any browser'],
    ],
  },
  benefits: {
    title: 'Everything it does for you',
    sub: 'Real in-game actions, automated on your own PC.',
    items: [
      { title: 'Auto Gathering', desc: 'Collects resources on the map without you opening the game.' },
      { title: 'Troop Training', desc: 'Keeps training queues always active to maximise your progress.' },
      { title: 'Auto Hunt', desc: 'Hunts monsters continuously to accumulate valuable items.' },
      { title: 'Auto Shield', desc: 'It watches for incoming attacks: it drops everything, activates a shield from your backpack and recalls your marching troops, staying in protected mode.' },
      { title: 'Intelligence', desc: '5 lookups a day: power, coordinates and last seen of any player or alliance, from the White Bot network.' },
      { title: 'Web control panel', desc: 'Configure, pause and monitor your bot from any browser, phone included.' },
    ],
  },
  steps: {
    title: 'How it works',
    sub: 'From download to active bot in minutes.',
    items: [
      { title: 'Create your account and start your trial', desc: 'Sign up on the product site and start your 5 free days.' },
      { title: 'Download and install the client', desc: 'Windows + BlueStacks. The setup guide walks you through every step.' },
      { title: 'Activate with your email', desc: 'Enter your email and activation code in the client. Done: client connected.' },
      { title: 'Control everything from the web', desc: 'Configure actions, pause or monitor from any device. The bot works on your PC.' },
    ],
  },
  pricing: {
    title: 'Pricing',
    sub: 'No lock-in. Cancel any time.',
    downloadable: {
      name: 'White Bot Desktop', badge: 'Available now', price: '€11.99', period: '/month',
      desc: '5-day free trial, no card. Then one plan with everything included.',
      features: ['Gathering, troop training, hunting and Auto Shield', 'Control from the web', '🔍 Intelligence: 5 lookups/day', 'Updates and support included'],
      cta: 'Try free for 5 days',
    },
    cloud: {
      name: 'White Bot Cloud', badge: 'In development', price: 'from €49.99', period: '/month',
      desc: 'Private beta. We run the bot for you, with exclusive features.',
      features: ['Runs 24/7 on our servers', 'Zero installs', 'Full, unlimited Intelligence', 'Limited seats'],
      cta: 'Notify me when it opens',
    },
    betaBadge: 'Beta · coming soon',
    soon: 'Coming soon',
    farm: { name: 'Farm', price: '€21.99', period: '/month', tagline: 'Up to 3 accounts at once' },
    farmPlus: { name: 'Farm+', price: '€49.99', period: '/month', tagline: 'Up to 10 accounts at once' },
  },
  trust: {
    title: 'Security & privacy',
    sub: 'Designed so you always stay in control.',
    items: [
      { title: 'No shared passwords', desc: 'You link your game account yourself, in your own BlueStacks. Your credentials never leave your PC.' },
      { title: 'Your PC, your control', desc: 'The bot runs on your machine and only talks to our servers to validate your licence and power your panel.' },
      { title: 'No lock-in', desc: 'Cancel anytime from the web. Access stays active until the end of the paid period.' },
      { title: 'Secure payments with Stripe', desc: 'Payments are processed by Stripe. Your card details never touch our servers.' },
    ],
  },
  risk: {
    title: 'Transparency about the risk',
    p1: 'White Bot automates in-game actions in an emulator running on your own PC. Using third-party software may violate the <strong>Terms of Service of Whiteout Survival</strong> and may lead to penalties by the game developer, including account restriction or suspension. The risk falls on your account and your machine.',
    p2: 'The bot is programmed to behave like a human player: variable action timings, natural pauses, and realistic cycles. <strong>To date, we have no confirmed ban among our users.</strong> The risk still exists and the user accepts it by using the product. See our <a href="/terms">Terms of Use</a>.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Have a question?',
    sub: 'Write to us and we\'ll reply within 24 hours.',
    label: 'Or email us directly:',
    fields: { name: 'Name', email: 'Email', subject: 'Subject', message: 'Message' },
    subjects: { consulta: 'General enquiry', soporte: 'Technical support', facturacion: 'Billing / subscription', baneo: 'Incident report', otro: 'Other' },
    submit: 'Send message', submitting: 'Sending…',
    successTitle: 'Message sent!', successBody: 'We\'ll get back to you within 24 hours.',
    errorMsg: 'Error sending. Please try again or email whitebot.admin@gmail.com',
    namePh: 'Your name', emailPh: 'you@email.com', messagePh: 'Tell us your question…',
  },
  vs: {
    title: 'Not another cloud farm',
    sub: 'Most Whiteout bots sell volume: cloud servers, unlimited accounts, "100x resources". White Bot is built for one account — yours.',
    them: {
      title: 'Cloud bots',
      items: [
        'Your login lives on someone else\'s server',
        'Built to run hundreds of throwaway farms',
        'Sell you "undetectable" — a promise nobody can keep',
        'If their server goes down, so does your bot',
      ],
    },
    us: {
      title: 'White Bot',
      items: [
        'Runs on your PC — your login never leaves your machine',
        'Built to grow and defend the account that matters',
        'Honest about the risk — human-like play, no magic promises',
        'Auto Shield: detects attacks, shields up, recalls your troops',
      ],
    },
    cta: 'Protect your city — try it free',
  },
  betaList: {
    title: 'Don\'t miss the free beta',
    body: 'The full bot is free until August 15, 2026 — paid plans start August 16. Leave your email and we\'ll remind you before it ends.',
    emailPh: 'you@email.com',
    submit: 'Keep me posted',
    submitting: 'Sending…',
    successTitle: 'Done!',
    successBody: 'We\'ll email you before the free beta ends.',
    errorMsg: 'Could not send. Please try again in a moment.',
    supportNote: 'Questions? Message us in the in-app support chat — we answer fast.',
  },
  beta: {
    hero: { badge: 'Free beta until August 15 · No commitment', cta1: 'Join the free beta' },
    stats: { s4v: 'Free', s4l: 'Beta until Aug 15, 2026 — no card' },
    stepTrial: {
      title: 'Create your account and join the beta',
      desc: 'Sign up on the product site — free during the beta, no card.',
    },
    downloadable: {
      badge: 'Free beta',
      trialFeature: 'Free beta until August 15, 2026 — no card',
      priceNote: 'Free until August 15, 2026 — then €11.99/month',
      cta: 'Join the free beta',
    },
    faq: {
      q: 'What does the free beta include?',
      a: 'Until August 15, 2026 White Bot Desktop is completely free: create your account, start the beta (no card needed) and use the full bot. On August 16 the normal model kicks in — a 5-day trial for new users and a €11.99/month subscription. We\'ll email beta users before it ends.',
    },
  },
  faq: {
    title: 'Frequently Asked Questions',
    items: [
      { q: 'What do I need to use White Bot?', a: 'A Windows PC, the free BlueStacks emulator, and your Whiteout Survival account. The bot installs on your PC and is controlled from the web, from any device.' },
      { q: 'Do I need to install anything?', a: 'Yes. Unlike cloud bots, White Bot runs on your own PC: you install the client and BlueStacks following the step-by-step guide. Day-to-day control is 100% web-based — no need to touch the PC.' },
      { q: 'Does the bot work with my PC turned off?', a: 'No. The bot runs on your PC, so it needs the machine on with BlueStacks open. You can close the browser and control the bot remotely at any time; what it cannot do is work with the machine switched off.' },
      { q: 'Does it work with new accounts?', a: 'No. White Bot is designed for players with established accounts. The system does not handle start-up tutorials or account creation. You need your account fully set up and ready to play before using the bot.' },
      { q: 'Can I get banned for using White Bot?', a: 'Yes, there is an inherent risk. Using automation software may violate Whiteout Survival\'s Terms of Service. White Bot is programmed to mimic human player behaviour: random action timings, natural pauses, and realistic cycles. To date we have no confirmed ban among our users. The bot runs on your PC with your account: the risk is yours and you expressly accept it (see Terms of Use).' },
      { q: 'What happens if I get banned?', a: 'White Bot provides the automation software; it does not guarantee in-game results or account safety against the game developer. If a sanction occurs, we evaluate each case individually. A ban clearly caused by a technical error on our part will be studied for a proportional refund. Bans arising from the inherent bot risk accepted in the Terms of Use do not generate an automatic refund.' },
      { q: 'How do I link my game account?', a: 'You do it yourself: you sign in to your account inside BlueStacks exactly as you would on your phone. We never see or store your credentials — they never leave your PC.' },
      { q: 'What does the 5-day trial include?', a: '5 days with the FULL bot, no card. Create your account, hit "Start free trial" and download the client — we ask for no payment details. When the trial ends the bot stops; if you like it, subscribe for €11.99/month and pick up right where you left off (your settings are kept). One trial per account and per PC.' },
      { q: 'How does Auto Shield work?', a: 'While the bot works it watches for incoming attacks. If it confirms one, it stops everything, activates a shield from your backpack, recalls your marching troops and stays in protected mode until you resume. Note: it uses shields you already own in your backpack (it does not buy them), and it is not an absolute guarantee against instant attacks.' },
      { q: 'Which language does the game need to be in?', a: 'English or Spanish. You can change the configured game language from the web at any time.' },
      { q: 'Can I pause or stop the bot at any time?', a: 'Yes. From the web panel you can stop, pause, or reconfigure the bot immediately, from any device.' },
      { q: 'How do I cancel my subscription?', a: 'You can cancel at any time from the web. Access remains active until the end of the current billing period. No lock-in, no penalty.' },
      { q: 'What is White Bot Cloud?', a: 'It\'s the hosted version: the bot runs on our servers 24/7, with zero installs and full, unlimited regional Intelligence (Desktop includes 5 lookups a day). It is in development, in private beta. When it opens it will be a premium tier (from €49.99/month). Leave your email in the products section and we\'ll notify you.' },
    ],
  },
  blog: {
    sectionTitle: 'Guides & strategies',
    sectionSub: 'Learn how to grow faster in Whiteout Survival.',
    readMore: 'Read guide →',
    viewAll: 'View all guides',
  },
  footer: {
    copy: '© 2026 White Bot · Not affiliated with Whiteout Survival or Century Games',
    links: { enter: 'Log in', faq: 'FAQ', contact: 'Contact', privacy: 'Privacy policy', terms: 'Terms of use', blog: 'Blog', status: 'Status' },
  },
  referral: {
    title: 'Invite friends, earn free days',
    body: 'Share your personal code and <strong>your friend gets an 8-day trial</strong> (3 extra days). When they become a paying customer, you earn <strong>+15 free days</strong> of service. Your code will be available in your panel once active.',
    stat1: '+3 days for your friend',
    stat2: '+15 days for you per conversion',
  },
  waitlist: {
    badge: 'All seats are full right now',
    title: 'Join the waitlist',
    body: 'Every White Bot seat is dedicated hardware, so we open access in waves. Leave your email and we will invite you automatically the moment a slot frees up.',
    emailPh: 'your@email.com',
    submit: 'Join the waitlist',
    submitting: 'Adding you…',
    successTitle: 'You are on the list',
    successBody: 'You are #{position} of {total}. We will email you an invite as soon as a seat opens — no need to check back.',
    invitedTitle: 'Your invite is on the way',
    invitedBody: 'A seat opened for you. Check your inbox for the invitation email to activate your account.',
    claimedTitle: 'You already have access',
    claimedBody: 'This email already has an account. Use the log in button to enter your dashboard.',
    errorMsg: 'Something went wrong. Please try again in a moment.',
    invalidEmail: 'Please enter a valid email address.',
    haveInvite: 'Already invited? Log in',
    ctaJoin: 'Join the waitlist',
    waitingCount: '{count} players already waiting',
  },
};

const es: Translations = {
  nav: { products: 'Productos', how: 'Cómo funciona', pricing: 'Precios', faq: 'FAQ', contact: 'Contacto', enter: 'Entrar' },
  hero: {
    badge: 'Prueba gratis 5 días · Sin permanencia',
    tagline: [
      'El bot de Whiteout Survival que protege tu ciudad mientras duermes —',
      'Auto Escudo detecta ataques, pone escudo y repliega tus tropas.',
      'Corre en tu propio PC. Controlado desde tu móvil.',
    ],
    cta1: 'Prueba gratis 5 días',
    cta2: 'Ver cómo funciona ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Bot trabajando en tu PC',
    s2v: '100% web', s2l: 'Control desde cualquier dispositivo',
    s3v: '0 baneos confirmados', s3l: 'Entre nuestros usuarios',
    s4v: '5 días', s4l: 'De prueba gratis, cancela cuando quieras',
  },
  products: {
    title: 'Elige tu White Bot',
    sub: 'El mismo bot, dos formas de ejecutarlo.',
    downloadable: {
      badge: 'Disponible ahora',
      name: 'White Bot Descargable',
      desc: 'El bot corre en tu PC con Windows y BlueStacks. Tú lo instalas, es tuyo — y lo controlas todo desde la web, estés donde estés.',
      features: [
        'Corre en tu PC (Windows + BlueStacks)',
        'Control total desde la web',
        'Recolección, entreno de tropas, caza y Auto Escudo',
        '🔍 Intelligence: 5 búsquedas/día incluidas',
        'Prueba gratis de 5 días — sin tarjeta',
      ],
      priceNote: '11,99 €/mes tras la prueba',
      cta: 'Prueba gratis 5 días',
    },
    cloud: {
      badge: 'En desarrollo — beta privada',
      name: 'White Bot Cloud',
      desc: 'Nosotros ejecutamos el bot por ti en nuestros servidores, 24/7, sin que instales nada. Ahora mismo en beta privada mientras lo terminamos.',
      features: [
        'Lo ejecutamos nosotros, 24/7',
        'Cero instalación — no necesitas PC',
        'Intelligence completa e ilimitada',
        'Plazas limitadas',
      ],
      priceNote: 'Desde 49,99 €/mes cuando abra',
      notifyLabel: '¿Te interesa? Te escribimos cuando abra:',
      betaAccess: '¿Ya en la beta privada? Entrar',
    },
  },
  cloudNotify: {
    emailPh: 'tu@email.com',
    submit: 'Avisadme cuando abra',
    submitting: 'Enviando…',
    successTitle: '¡Apuntado!',
    successBody: 'Te escribiremos a este email cuando White Bot Cloud abra sus puertas.',
    errorMsg: 'No se pudo enviar. Inténtalo de nuevo en un momento.',
  },
  forwhom: {
    yes: {
      title: 'Ideal para ti si…',
      items: [
        'Ya tienes una cuenta establecida en Whiteout Survival',
        'Tienes un PC con Windows donde el bot pueda correr',
        'Quieres progresar mientras trabajas, estudias o duermes',
        'Quieres controlar el bot desde el móvil, en cualquier lugar',
      ],
    },
    no: {
      title: 'Ten en cuenta que…',
      items: [
        'El bot necesita tu PC encendido, con BlueStacks abierto, mientras trabaja',
        'White Bot no gestiona tutoriales de inicio ni cuentas nuevas',
        'El uso de bots puede infringir los ToS del juego (ver FAQ)',
        'El juego debe estar en inglés o en español',
      ],
    },
  },
  compare: {
    title: 'Manual vs White Bot',
    sub: 'Lo mismo que harías tú, pero las 24 horas del día.',
    headers: ['', 'Jugando manualmente', 'Con White Bot'],
    rows: [
      ['Horario activo', 'Solo cuando juegas', '24 h / 7 días'],
      ['Recolección de recursos', 'Limitada a tus sesiones', 'Continua y maximizada'],
      ['Cola de tropas', 'A veces la olvidas vacía', 'Siempre activa'],
      ['Caza de monstruos', 'Pocos por día', 'Decenas de ciclos al día'],
      ['Tiempo tuyo invertido', '2–3 horas diarias', '0 horas'],
      ['Control desde móvil', 'Solo el juego en sí', 'Panel completo desde el navegador'],
    ],
  },
  benefits: {
    title: 'Todo lo que hace por ti',
    sub: 'Acciones reales del juego, automatizadas en tu propio PC.',
    items: [
      { title: 'Recolección automática', desc: 'Recolecta recursos en el mapa sin que tengas que abrir el juego.' },
      { title: 'Entrenamiento de tropas', desc: 'Mantiene las colas de entrenamiento siempre activas para maximizar tu progreso.' },
      { title: 'Auto Hunt', desc: 'Caza monstruos de forma continua para acumular objetos valiosos.' },
      { title: 'Auto Escudo', desc: 'Vigila los ataques entrantes: lo suelta todo, activa un escudo de tu mochila y repliega tus marchas, quedando en modo protegido.' },
      { title: 'Intelligence', desc: '5 búsquedas al día: poder, coordenadas y última conexión de cualquier jugador o alianza, desde la red White Bot.' },
      { title: 'Panel de control web', desc: 'Configura, pausa y supervisa tu bot desde cualquier navegador, también en el móvil.' },
    ],
  },
  steps: {
    title: 'Cómo funciona',
    sub: 'De la descarga al bot activo en minutos.',
    items: [
      { title: 'Crea tu cuenta y activa tu prueba', desc: 'Regístrate en la web del producto y empieza tus 5 días gratis.' },
      { title: 'Descarga e instala el cliente', desc: 'Windows + BlueStacks. La guía de instalación te acompaña paso a paso.' },
      { title: 'Actívalo con tu email', desc: 'Introduce tu email y el código de activación en el cliente. Listo: cliente conectado.' },
      { title: 'Contrólalo todo desde la web', desc: 'Configura acciones, pausa o supervisa desde cualquier dispositivo. El bot trabaja en tu PC.' },
    ],
  },
  pricing: {
    title: 'Precios',
    sub: 'Sin permanencia. Cancela cuando quieras.',
    downloadable: {
      name: 'White Bot Descargable', badge: 'Disponible ahora', price: '11,99 €', period: '/mes',
      desc: 'Prueba gratis 5 días, sin tarjeta. Después, un único plan con todo incluido.',
      features: ['Recolección, entreno de tropas, caza y Auto Escudo', 'Control desde la web', '🔍 Intelligence: 5 búsquedas/día', 'Actualizaciones y soporte incluidos'],
      cta: 'Prueba gratis 5 días',
    },
    cloud: {
      name: 'White Bot Cloud', badge: 'En desarrollo', price: 'desde 49,99 €', period: '/mes',
      desc: 'Beta privada. Nosotros ejecutamos el bot por ti, con funciones exclusivas.',
      features: ['Ejecución 24/7 en nuestros servidores', 'Cero instalación', 'Intelligence completa e ilimitada', 'Plazas limitadas'],
      cta: 'Avisadme cuando abra',
    },
    betaBadge: 'Beta · próximamente',
    soon: 'Próximamente',
    farm: { name: 'Granja', price: '21,99 €', period: '/mes', tagline: 'Hasta 3 cuentas a la vez' },
    farmPlus: { name: 'Granja+', price: '49,99 €', period: '/mes', tagline: 'Hasta 10 cuentas a la vez' },
  },
  trust: {
    title: 'Seguridad y privacidad',
    sub: 'Diseñado para que siempre tengas el control.',
    items: [
      { title: 'Sin contraseñas compartidas', desc: 'Vinculas tu cuenta del juego tú mismo, en tu propio BlueStacks. Tus credenciales nunca salen de tu PC.' },
      { title: 'Tu PC, tu control', desc: 'El bot corre en tu máquina y solo se comunica con nuestros servidores para validar tu licencia y alimentar tu panel.' },
      { title: 'Sin permanencia', desc: 'Cancela cuando quieras desde la web. El acceso sigue activo hasta el final del período pagado.' },
      { title: 'Pagos seguros con Stripe', desc: 'El pago lo procesa Stripe. Tus datos de tarjeta nunca pasan por nuestros servidores.' },
    ],
  },
  risk: {
    title: 'Transparencia sobre el riesgo',
    p1: 'White Bot automatiza acciones dentro del juego en un emulador que corre en tu propio PC. El uso de software de terceros puede infringir los <strong>Términos de Servicio de Whiteout Survival</strong> y puede conllevar sanciones por parte del desarrollador del juego, incluyendo restricción o suspensión de cuenta. El riesgo recae sobre tu cuenta y tu equipo.',
    p2: 'El bot está programado para comportarse como un jugador humano: tiempos de acción variables, pausas naturales y ciclos realistas. <strong>Hasta la fecha, no tenemos ningún caso confirmado de baneo entre nuestros usuarios.</strong> El riesgo existe y el usuario lo acepta al usar el producto. Consulta nuestros <a href="/terminos">Términos de Uso</a>.',
    termsLink: '/terminos',
  },
  contact: {
    title: '¿Tienes alguna pregunta?',
    sub: 'Escríbenos y te respondemos en menos de 24 horas.',
    label: 'O escríbenos directamente:',
    fields: { name: 'Nombre', email: 'Email', subject: 'Asunto', message: 'Mensaje' },
    subjects: { consulta: 'Consulta general', soporte: 'Soporte técnico', facturacion: 'Facturación / suscripción', baneo: 'Reporte de incidencia', otro: 'Otro' },
    submit: 'Enviar mensaje', submitting: 'Enviando…',
    successTitle: '¡Mensaje enviado!', successBody: 'Te responderemos en menos de 24 horas.',
    errorMsg: 'Error al enviar. Intenta de nuevo o escríbenos a whitebot.admin@gmail.com',
    namePh: 'Tu nombre', emailPh: 'tu@email.com', messagePh: 'Cuéntanos tu consulta…',
  },
  vs: {
    title: 'No somos otra granja en la nube',
    sub: 'La mayoría de los bots de Whiteout venden volumen: servidores en la nube, cuentas ilimitadas, "recursos x100". White Bot está hecho para una cuenta — la tuya.',
    them: {
      title: 'Bots en la nube',
      items: [
        'Tu login vive en el servidor de otro',
        'Hechos para llevar cientos de granjas desechables',
        'Te venden "indetectable" — una promesa que nadie puede cumplir',
        'Si su servidor cae, tu bot también',
      ],
    },
    us: {
      title: 'White Bot',
      items: [
        'Corre en tu PC — tu login nunca sale de tu máquina',
        'Hecho para crecer y defender la cuenta que importa',
        'Honesto con el riesgo — juego humano, sin promesas mágicas',
        'Auto Escudo: detecta ataques, pone escudo y repliega tropas',
      ],
    },
    cta: 'Protege tu ciudad — pruébalo gratis',
  },
  betaList: {
    title: 'No te pierdas la beta gratuita',
    body: 'El bot completo es gratis hasta el 15 de agosto de 2026 — los planes de pago empiezan el 16. Deja tu email y te avisamos antes de que termine.',
    emailPh: 'tu@email.com',
    submit: 'Avisadme',
    submitting: 'Enviando…',
    successTitle: '¡Hecho!',
    successBody: 'Te escribiremos antes de que acabe la beta gratuita.',
    errorMsg: 'No se pudo enviar. Inténtalo de nuevo en un momento.',
    supportNote: '¿Dudas? Escríbenos por el chat de soporte de la app — respondemos rápido.',
  },
  beta: {
    hero: { badge: 'Beta gratuita hasta el 15 de agosto · Sin permanencia', cta1: 'Únete a la beta gratis' },
    stats: { s4v: 'Gratis', s4l: 'Beta hasta el 15 ago 2026, sin tarjeta' },
    stepTrial: {
      title: 'Crea tu cuenta y únete a la beta',
      desc: 'Regístrate en la web del producto — gratis durante la beta, sin tarjeta.',
    },
    downloadable: {
      badge: 'Beta gratuita',
      trialFeature: 'Beta gratuita hasta el 15 de agosto de 2026 — sin tarjeta',
      priceNote: 'Gratis hasta el 15 de agosto de 2026 — después 11,99 €/mes',
      cta: 'Únete a la beta gratis',
    },
    faq: {
      q: '¿Qué incluye la beta gratuita?',
      a: 'Hasta el 15 de agosto de 2026, White Bot Descargable es totalmente gratis: crea tu cuenta, empieza la beta (sin tarjeta) y usa el bot completo. El 16 de agosto entra el modelo normal — prueba de 5 días para nuevos usuarios y suscripción de 11,99 €/mes. Avisaremos por email a los usuarios de la beta antes de que termine.',
    },
  },
  faq: {
    title: 'Preguntas frecuentes',
    items: [
      { q: '¿Qué necesito para usar White Bot?', a: 'Un PC con Windows, el emulador gratuito BlueStacks y tu cuenta de Whiteout Survival. El bot se instala en tu PC y se controla desde la web, desde cualquier dispositivo.' },
      { q: '¿Necesito instalar algo?', a: 'Sí. A diferencia de los bots en la nube, White Bot corre en tu propio PC: instalas el cliente y BlueStacks siguiendo la guía paso a paso. El control del día a día es 100% web — sin tocar el PC.' },
      { q: '¿El bot funciona con el PC apagado?', a: 'No. El bot corre en tu PC, así que necesita la máquina encendida con BlueStacks abierto. Puedes cerrar el navegador y controlar el bot a distancia en todo momento; lo que no puede es trabajar con la máquina apagada.' },
      { q: '¿Funciona con cuentas nuevas?', a: 'No. White Bot está diseñado para jugadores con cuentas ya establecidas. El sistema no gestiona tutoriales de inicio ni el proceso de creación de cuenta. Necesitas tener tu cuenta configurada y lista para jugar antes de usar el bot.' },
      { q: '¿Puedo ser baneado por usar White Bot?', a: 'Sí, existe un riesgo inherente. El uso de software de automatización puede infringir los Términos de Servicio de Whiteout Survival. White Bot está programado para imitar el comportamiento de un jugador humano: tiempos de acción aleatorios, pausas naturales y ciclos realistas. A fecha de hoy no tenemos ningún caso confirmado de baneo entre nuestros usuarios. El bot corre en tu PC y con tu cuenta: el riesgo es tuyo y lo aceptas expresamente (ver Términos de Uso).' },
      { q: '¿Qué ocurre si me banean?', a: 'White Bot ofrece el software de automatización; no garantiza resultados en el juego ni la seguridad de tu cuenta frente al desarrollador. Si se produce una sanción, evaluamos cada caso individualmente. Un baneo causado por un error técnico nuestro será estudiado para reembolso proporcional. Las sanciones por riesgo inherente aceptado en los Términos no generan reembolso automático.' },
      { q: '¿Cómo se vincula mi cuenta del juego?', a: 'La vinculas tú mismo: entras en tu cuenta dentro de BlueStacks igual que lo harías en tu móvil. Nosotros nunca vemos ni almacenamos tus credenciales — no salen de tu PC.' },
      { q: '¿Qué incluye la prueba de 5 días?', a: '5 días con TODO el bot, sin tarjeta. Crea tu cuenta, pulsa "Empezar prueba gratis" y descarga el cliente: no pedimos ningún dato de pago. Al terminar la prueba, el bot se detiene; si te convence, te suscribes por 11,99 €/mes y sigues donde lo dejaste (tu configuración se conserva). Una prueba por cuenta y por PC.' },
      { q: '¿Cómo funciona Auto Escudo?', a: 'Mientras el bot trabaja, vigila los ataques entrantes. Si confirma uno, detiene todo, activa un escudo de tu mochila, repliega tus marchas y queda en modo protegido hasta que reanudes. Nota: usa escudos que ya tengas en tu mochila (no los compra) y no es una garantía absoluta frente a ataques relámpago.' },
      { q: '¿En qué idioma tiene que estar el juego?', a: 'En inglés o en español. Puedes cambiar el idioma configurado desde la web en cualquier momento.' },
      { q: '¿Puedo pausar o parar el bot en cualquier momento?', a: 'Sí. Desde el panel web puedes detener, pausar o reconfigurar el bot inmediatamente, desde cualquier dispositivo.' },
      { q: '¿Cómo cancelo la suscripción?', a: 'Puedes cancelar en cualquier momento desde la web. El acceso permanece activo hasta el final del período de facturación en curso. Sin permanencia ni penalización.' },
      { q: '¿Qué es White Bot Cloud?', a: 'Es la versión hosted: el bot corre en nuestros servidores 24/7, sin instalación y con Inteligencia regional completa e ilimitada (el Descargable incluye 5 búsquedas al día). Está en desarrollo, en beta privada. Cuando abra será un plan premium (desde 49,99 €/mes). Deja tu email en la sección de productos y te avisamos.' },
    ],
  },
  blog: {
    sectionTitle: 'Guías y estrategias',
    sectionSub: 'Aprende a crecer más rápido en Whiteout Survival.',
    readMore: 'Leer guía →',
    viewAll: 'Ver todas las guías',
  },
  footer: {
    copy: '© 2026 White Bot · No afiliado a Whiteout Survival ni Century Games',
    links: { enter: 'Entrar', faq: 'FAQ', contact: 'Contacto', privacy: 'Política de privacidad', terms: 'Términos de uso', blog: 'Blog', status: 'Estado' },
  },
  referral: {
    title: 'Invita amigos, gana días gratis',
    body: 'Comparte tu código personal y <strong>tu amigo obtiene 8 días de trial</strong> (3 extra). Cuando se convierta en cliente de pago, tú acumulas <strong>+15 días gratis</strong> de servicio. Tu código estará disponible en tu panel una vez activo.',
    stat1: '+3 días para tu amigo',
    stat2: '+15 días para ti por conversión',
  },
  waitlist: {
    badge: 'Sin plazas disponibles ahora mismo',
    title: 'Apúntate a la lista de espera',
    body: 'Cada plaza de White Bot es hardware dedicado, así que abrimos el acceso por tandas. Déjanos tu email y te invitaremos automáticamente en cuanto se libere una plaza.',
    emailPh: 'tu@email.com',
    submit: 'Apuntarme a la lista',
    submitting: 'Apuntándote…',
    successTitle: 'Ya estás en la lista',
    successBody: 'Eres el #{position} de {total}. Te enviaremos un email con la invitación en cuanto se libere una plaza — no necesitas estar pendiente.',
    invitedTitle: 'Tu invitación está en camino',
    invitedBody: 'Se ha liberado una plaza para ti. Revisa tu correo para activar tu cuenta con el email de invitación.',
    claimedTitle: 'Ya tienes acceso',
    claimedBody: 'Este email ya tiene una cuenta. Usa el botón de iniciar sesión para entrar a tu panel.',
    errorMsg: 'Algo ha fallado. Inténtalo de nuevo en un momento.',
    invalidEmail: 'Introduce un email válido.',
    haveInvite: '¿Ya tienes invitación? Iniciar sesión',
    ctaJoin: 'Apuntarme a la lista',
    waitingCount: 'Ya hay {count} jugadores esperando',
  },
};

const pt: Translations = {
  nav: { products: 'Produtos', how: 'Como funciona', pricing: 'Planos', faq: 'FAQ', contact: 'Contato', enter: 'Entrar' },
  hero: {
    badge: '5 dias grátis · Sem fidelidade',
    tagline: [
      'O bot de Whiteout Survival que protege sua cidade enquanto você dorme —',
      'O Auto Escudo detecta ataques, ativa o escudo e recolhe suas tropas.',
      'Roda no seu próprio PC. Controlado pelo celular.',
    ],
    cta1: 'Testar 5 dias grátis',
    cta2: 'Ver como funciona ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Bot trabalhando no seu PC',
    s2v: '100% web', s2l: 'Controle de qualquer dispositivo',
    s3v: '0 banimentos confirmados', s3l: 'Entre nossos usuários',
    s4v: '5 dias', s4l: 'De teste grátis, cancele quando quiser',
  },
  products: {
    title: 'Escolha seu White Bot',
    sub: 'O mesmo bot, duas formas de executá-lo.',
    downloadable: {
      badge: 'Disponível agora',
      name: 'White Bot Desktop',
      desc: 'O bot roda no seu PC com Windows e BlueStacks. Você o instala, ele é seu — e controla tudo pela web, onde estiver.',
      features: [
        'Roda no seu PC (Windows + BlueStacks)',
        'Controle total pela web',
        'Coleta, treino de tropas, caça e Auto Escudo',
        '🔍 Intelligence: 5 buscas/dia incluídas',
        'Teste grátis de 5 dias — sem cartão',
      ],
      priceNote: '€11,99/mês após o teste',
      cta: 'Testar 5 dias grátis',
    },
    cloud: {
      badge: 'Em desenvolvimento — beta privado',
      name: 'White Bot Cloud',
      desc: 'Nós executamos o bot por você em nossos servidores, 24/7, sem instalar nada. No momento em beta privado enquanto o finalizamos.',
      features: [
        'Executado por nós, 24/7',
        'Zero instalação — nem PC necessário',
        'Intelligence completa e ilimitada',
        'Vagas limitadas',
      ],
      priceNote: 'A partir de €49,99/mês quando abrir',
      notifyLabel: 'Interessado? Escrevemos quando abrir:',
      betaAccess: 'Já está na beta privada? Entrar',
    },
  },
  cloudNotify: {
    emailPh: 'voce@email.com',
    submit: 'Avise-me quando abrir',
    submitting: 'Enviando…',
    successTitle: 'Anotado!',
    successBody: 'Escreveremos para este email quando o White Bot Cloud abrir as portas.',
    errorMsg: 'Não foi possível enviar. Tente novamente em instantes.',
  },
  forwhom: {
    yes: {
      title: 'Ideal para você se…',
      items: [
        'Você já tem uma conta estabelecida no Whiteout Survival',
        'Tem um PC com Windows onde o bot possa rodar',
        'Quer progredir enquanto trabalha, estuda ou dorme',
        'Quer controlar o bot pelo celular, de qualquer lugar',
      ],
    },
    no: {
      title: 'Atenção…',
      items: [
        'O bot precisa do seu PC ligado, com BlueStacks aberto, enquanto trabalha',
        'White Bot não gerencia tutoriais iniciais nem contas novas',
        'Usar bots pode violar os ToS do jogo (ver FAQ)',
        'O jogo deve estar em inglês ou espanhol',
      ],
    },
  },
  compare: {
    title: 'Manual vs White Bot',
    sub: 'As mesmas ações que você faria — mas 24 horas por dia.',
    headers: ['', 'Jogando manualmente', 'Com White Bot'],
    rows: [
      ['Horário ativo', 'Só quando você joga', '24 h / 7 dias'],
      ['Coleta de recursos', 'Limitada às suas sessões', 'Contínua e maximizada'],
      ['Fila de tropas', 'Às vezes esquecida vazia', 'Sempre ativa'],
      ['Caça de monstros', 'Poucos por dia', 'Dezenas de ciclos por dia'],
      ['Seu tempo investido', '2–3 horas diárias', '0 horas'],
      ['Controle pelo celular', 'Só o aplicativo do jogo', 'Painel completo no navegador'],
    ],
  },
  benefits: {
    title: 'Tudo o que ele faz por você',
    sub: 'Ações reais do jogo, automatizadas no seu próprio PC.',
    items: [
      { title: 'Coleta automática', desc: 'Coleta recursos no mapa sem você precisar abrir o jogo.' },
      { title: 'Treinamento de tropas', desc: 'Mantém as filas de treinamento sempre ativas para maximizar seu progresso.' },
      { title: 'Auto Hunt', desc: 'Caça monstros continuamente para acumular itens valiosos.' },
      { title: 'Auto Escudo', desc: 'Vigia os ataques recebidos: larga tudo, ativa um escudo da tua mochila e recolhe tuas marchas, ficando em modo protegido.' },
      { title: 'Intelligence', desc: '5 buscas por dia: poder, coordenadas e última conexão de qualquer jogador ou aliança, a partir da rede White Bot.' },
      { title: 'Painel de controle web', desc: 'Configure, pause e supervisione seu bot de qualquer navegador, inclusive no celular.' },
    ],
  },
  steps: {
    title: 'Como funciona',
    sub: 'Do download ao bot ativo em minutos.',
    items: [
      { title: 'Crie sua conta e ative seu teste', desc: 'Cadastre-se no site do produto e comece seus 5 dias grátis.' },
      { title: 'Baixe e instale o cliente', desc: 'Windows + BlueStacks. O guia de instalação acompanha você passo a passo.' },
      { title: 'Ative com seu email', desc: 'Digite seu email e o código de ativação no cliente. Pronto: cliente conectado.' },
      { title: 'Controle tudo pela web', desc: 'Configure ações, pause ou supervisione de qualquer dispositivo. O bot trabalha no seu PC.' },
    ],
  },
  pricing: {
    title: 'Planos',
    sub: 'Sem fidelidade. Cancele quando quiser.',
    downloadable: {
      name: 'White Bot Desktop', badge: 'Disponível agora', price: '€11,99', period: '/mês',
      desc: 'Teste grátis de 5 dias, sem cartão. Depois, um único plano com tudo incluído.',
      features: ['Coleta, treino de tropas, caça e Auto Escudo', 'Controle pela web', '🔍 Intelligence: 5 buscas/dia', 'Atualizações e suporte incluídos'],
      cta: 'Testar 5 dias grátis',
    },
    cloud: {
      name: 'White Bot Cloud', badge: 'Em desenvolvimento', price: 'desde €49,99', period: '/mês',
      desc: 'Beta privado. Nós executamos o bot por você, com funções exclusivas.',
      features: ['Execução 24/7 em nossos servidores', 'Zero instalação', 'Intelligence completa e ilimitada', 'Vagas limitadas'],
      cta: 'Avise-me quando abrir',
    },
    betaBadge: 'Beta · em breve',
    soon: 'Em breve',
    farm: { name: 'Fazenda', price: '€21,99', period: '/mês', tagline: 'Até 3 contas ao mesmo tempo' },
    farmPlus: { name: 'Fazenda+', price: '€49,99', period: '/mês', tagline: 'Até 10 contas ao mesmo tempo' },
  },
  trust: {
    title: 'Segurança e privacidade',
    sub: 'Desenvolvido para que você sempre tenha o controle.',
    items: [
      { title: 'Sem senhas compartilhadas', desc: 'Você vincula sua conta do jogo você mesmo, no seu próprio BlueStacks. Suas credenciais nunca saem do seu PC.' },
      { title: 'Seu PC, seu controle', desc: 'O bot roda na sua máquina e só se comunica com nossos servidores para validar sua licença e alimentar seu painel.' },
      { title: 'Sem fidelidade', desc: 'Cancele quando quiser pela web. O acesso continua ativo até o fim do período pago.' },
      { title: 'Pagamentos seguros com Stripe', desc: 'O pagamento é processado pela Stripe. Os dados do seu cartão nunca passam pelos nossos servidores.' },
    ],
  },
  risk: {
    title: 'Transparência sobre o risco',
    p1: 'White Bot automatiza ações no jogo em um emulador que roda no seu próprio PC. O uso de software de terceiros pode violar os <strong>Termos de Serviço do Whiteout Survival</strong> e pode resultar em penalidades pelo desenvolvedor, incluindo restrição ou suspensão da conta. O risco recai sobre sua conta e sua máquina.',
    p2: 'O bot é programado para imitar o comportamento humano: tempos de ação variáveis, pausas naturais e ciclos realistas. <strong>Até o momento, não temos nenhum banimento confirmado entre nossos usuários.</strong> O risco existe e o usuário o aceita ao usar o produto. Veja nossos <a href="/terms">Termos de Uso</a>.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Tem alguma dúvida?',
    sub: 'Escreva para nós e respondemos em até 24 horas.',
    label: 'Ou envie um email diretamente:',
    fields: { name: 'Nome', email: 'Email', subject: 'Assunto', message: 'Mensagem' },
    subjects: { consulta: 'Dúvida geral', soporte: 'Suporte técnico', facturacion: 'Cobrança / assinatura', baneo: 'Relato de incidente', otro: 'Outro' },
    submit: 'Enviar mensagem', submitting: 'Enviando…',
    successTitle: 'Mensagem enviada!', successBody: 'Responderemos em até 24 horas.',
    errorMsg: 'Erro ao enviar. Tente novamente ou escreva para whitebot.admin@gmail.com',
    namePh: 'Seu nome', emailPh: 'voce@email.com', messagePh: 'Conte sua dúvida…',
  },
  vs: {
    title: 'Não somos mais uma fazenda na nuvem',
    sub: 'A maioria dos bots de Whiteout vende volume: servidores na nuvem, contas ilimitadas, "recursos x100". O White Bot foi feito para uma conta — a sua.',
    them: {
      title: 'Bots na nuvem',
      items: [
        'Seu login mora no servidor de outra pessoa',
        'Feitos para rodar centenas de farms descartáveis',
        'Vendem "indetectável" — uma promessa que ninguém pode cumprir',
        'Se o servidor deles cai, seu bot cai junto',
      ],
    },
    us: {
      title: 'White Bot',
      items: [
        'Roda no seu PC — seu login nunca sai da sua máquina',
        'Feito para crescer e defender a conta que importa',
        'Honesto sobre o risco — jogo humano, sem promessas mágicas',
        'Auto Escudo: detecta ataques, ativa escudo e recolhe tropas',
      ],
    },
    cta: 'Proteja sua cidade — teste grátis',
  },
  betaList: {
    title: 'Não perca a beta gratuita',
    body: 'O bot completo é grátis até 15 de agosto de 2026 — os planos pagos começam em 16 de agosto. Deixe seu email e avisamos antes de terminar.',
    emailPh: 'voce@email.com',
    submit: 'Me avise',
    submitting: 'Enviando…',
    successTitle: 'Pronto!',
    successBody: 'Vamos escrever antes de a beta gratuita terminar.',
    errorMsg: 'Não foi possível enviar. Tente novamente em instantes.',
    supportNote: 'Dúvidas? Fale conosco no chat de suporte do app — respondemos rápido.',
  },
  beta: {
    hero: { badge: 'Beta gratuita até 15 de agosto · Sem fidelidade', cta1: 'Junte-se à beta grátis' },
    stats: { s4v: 'Grátis', s4l: 'Beta até 15 ago 2026, sem cartão' },
    stepTrial: {
      title: 'Crie sua conta e junte-se à beta',
      desc: 'Cadastre-se no site do produto — grátis durante a beta, sem cartão.',
    },
    downloadable: {
      badge: 'Beta gratuita',
      trialFeature: 'Beta gratuita até 15 de agosto de 2026 — sem cartão',
      priceNote: 'Grátis até 15 de agosto de 2026 — depois €11,99/mês',
      cta: 'Junte-se à beta grátis',
    },
    faq: {
      q: 'O que inclui a beta gratuita?',
      a: 'Até 15 de agosto de 2026, o White Bot Desktop é totalmente grátis: crie sua conta, comece a beta (sem cartão) e use o bot completo. Em 16 de agosto entra o modelo normal — teste de 5 dias para novos usuários e assinatura de €11,99/mês. Avisaremos os usuários da beta por email antes de terminar.',
    },
  },
  faq: {
    title: 'Perguntas frequentes',
    items: [
      { q: 'O que preciso para usar o White Bot?', a: 'Um PC com Windows, o emulador gratuito BlueStacks e sua conta do Whiteout Survival. O bot é instalado no seu PC e controlado pela web, de qualquer dispositivo.' },
      { q: 'Preciso instalar algo?', a: 'Sim. Diferente dos bots na nuvem, o White Bot roda no seu próprio PC: você instala o cliente e o BlueStacks seguindo o guia passo a passo. O controle do dia a dia é 100% web — sem tocar no PC.' },
      { q: 'O bot funciona com o PC desligado?', a: 'Não. O bot roda no seu PC, então precisa da máquina ligada com o BlueStacks aberto. Você pode fechar o navegador e controlar o bot à distância a qualquer momento; o que ele não pode é trabalhar com a máquina desligada.' },
      { q: 'Funciona com contas novas?', a: 'Não. O White Bot é projetado para jogadores com contas já estabelecidas. O sistema não gerencia tutoriais iniciais nem criação de conta. Você precisa ter sua conta configurada e pronta antes de usar o bot.' },
      { q: 'Posso ser banido por usar o White Bot?', a: 'Sim, existe um risco inerente. O uso de software de automação pode violar os Termos de Serviço do Whiteout Survival. O bot é programado para imitar o comportamento humano: tempos aleatórios, pausas naturais e ciclos realistas. Até hoje não temos nenhum banimento confirmado entre nossos usuários. O bot roda no seu PC e com a sua conta: o risco é seu e você o aceita expressamente (ver Termos de Uso).' },
      { q: 'O que acontece se eu for banido?', a: 'O White Bot oferece o software de automação; não garante resultados no jogo nem a segurança da conta frente ao desenvolvedor. Se ocorrer uma penalidade, avaliamos cada caso individualmente. Um banimento causado por erro técnico nosso será estudado para reembolso proporcional. Penalidades por risco inerente aceito nos Termos não geram reembolso automático.' },
      { q: 'Como vinculo minha conta do jogo?', a: 'Você mesmo faz: entra na sua conta dentro do BlueStacks exatamente como faria no celular. Nunca vemos nem armazenamos suas credenciais — elas não saem do seu PC.' },
      { q: 'O que inclui o teste de 5 dias?', a: '5 dias com o bot COMPLETO, sem cartão. Cria tua conta, clica em "Começar teste grátis" e baixa o cliente: não pedimos nenhum dado de pagamento. Ao terminar o teste, o bot para; se gostares, assinas por €11,99/mês e continuas de onde paraste (tua configuração é mantida). Um teste por conta e por PC.' },
      { q: 'Como funciona o Auto Escudo?', a: 'Enquanto o bot trabalha, vigia os ataques recebidos. Se confirmar um, para tudo, ativa um escudo da tua mochila, recolhe tuas marchas e fica em modo protegido até retomares. Nota: usa escudos que já tenhas na mochila (não os compra) e não é uma garantia absoluta contra ataques relâmpago.' },
      { q: 'Em que idioma o jogo precisa estar?', a: 'Em inglês ou espanhol. Você pode trocar o idioma configurado pela web a qualquer momento.' },
      { q: 'Posso pausar ou parar o bot a qualquer momento?', a: 'Sim. No painel web você pode parar, pausar ou reconfigurar o bot imediatamente, de qualquer dispositivo.' },
      { q: 'Como cancelo a assinatura?', a: 'Você pode cancelar a qualquer momento pela web. O acesso permanece ativo até o fim do período de cobrança atual. Sem fidelidade, sem penalidade.' },
      { q: 'O que é o White Bot Cloud?', a: 'É a versão hospedada: o bot roda em nossos servidores 24/7, sem instalação e com Inteligência regional completa e ilimitada (o Desktop inclui 5 buscas por dia). Está em desenvolvimento, em beta privado. Quando abrir será um plano premium (a partir de €49,99/mês). Deixe seu email na seção de produtos e avisaremos.' },
    ],
  },
  blog: {
    sectionTitle: 'Guias e estratégias',
    sectionSub: 'Aprenda a crescer mais rápido no Whiteout Survival.',
    readMore: 'Ler guia →',
    viewAll: 'Ver todos os guias',
  },
  footer: {
    copy: '© 2026 White Bot · Não afiliado ao Whiteout Survival ou Century Games',
    links: { enter: 'Entrar', faq: 'FAQ', contact: 'Contato', privacy: 'Política de privacidade', terms: 'Termos de uso', blog: 'Blog', status: 'Status' },
  },
  referral: {
    title: 'Indique amigos, ganhe dias grátis',
    body: 'Compartilhe seu código pessoal e <strong>seu amigo ganha 8 dias de trial</strong> (3 extras). Quando ele se tornar cliente pagante, você acumula <strong>+15 dias grátis</strong>. Seu código estará disponível no painel assim que ativo.',
    stat1: '+3 dias para seu amigo',
    stat2: '+15 dias para você por conversão',
  },
  waitlist: {
    badge: 'Sem vagas disponíveis no momento',
    title: 'Entre na lista de espera',
    body: 'Cada vaga do White Bot é hardware dedicado, por isso liberamos o acesso em ondas. Deixe seu email e enviaremos um convite automaticamente assim que uma vaga abrir.',
    emailPh: 'seu@email.com',
    submit: 'Entrar na lista',
    submitting: 'Adicionando você…',
    successTitle: 'Você está na lista',
    successBody: 'Você é o #{position} de {total}. Enviaremos um convite por email assim que uma vaga abrir — não precisa ficar verificando.',
    invitedTitle: 'Seu convite está a caminho',
    invitedBody: 'Uma vaga abriu para você. Verifique seu email para ativar sua conta com o convite.',
    claimedTitle: 'Você já tem acesso',
    claimedBody: 'Este email já tem uma conta. Use o botão entrar para acessar seu painel.',
    errorMsg: 'Algo deu errado. Tente novamente em instantes.',
    invalidEmail: 'Digite um email válido.',
    haveInvite: 'Já foi convidado? Entrar',
    ctaJoin: 'Entrar na lista',
    waitingCount: 'Já há {count} jogadores esperando',
  },
};

const fr: Translations = {
  nav: { products: 'Produits', how: 'Fonctionnement', pricing: 'Tarifs', faq: 'FAQ', contact: 'Contact', enter: 'Connexion' },
  hero: {
    badge: '5 jours d\'essai gratuit · Sans engagement',
    tagline: [
      'Le bot Whiteout Survival qui protège votre ville pendant votre sommeil —',
      'L\'Auto Bouclier détecte les attaques, active un bouclier et rappelle vos troupes.',
      'Tourne sur votre propre PC. Contrôlé depuis votre téléphone.',
    ],
    cta1: 'Essayer 5 jours gratuitement',
    cta2: 'Voir comment ça marche ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Bot au travail sur votre PC',
    s2v: '100% web', s2l: 'Contrôle depuis n\'importe quel appareil',
    s3v: '0 ban confirmé', s3l: 'Parmi nos utilisateurs',
    s4v: '5 jours', s4l: 'D\'essai gratuit, annulez quand vous voulez',
  },
  products: {
    title: 'Choisissez votre White Bot',
    sub: 'Le même bot, deux façons de l\'exécuter.',
    downloadable: {
      badge: 'Disponible maintenant',
      name: 'White Bot Desktop',
      desc: 'Le bot tourne sur votre PC avec Windows et BlueStacks. Vous l\'installez, il est à vous — et vous contrôlez tout depuis le web, où que vous soyez.',
      features: [
        'Tourne sur votre PC (Windows + BlueStacks)',
        'Contrôle total depuis le web',
        'Collecte, entraînement des troupes, chasse et Auto Bouclier',
        '🔍 Intelligence : 5 recherches/jour incluses',
        '5 jours d\'essai gratuit — sans carte',
      ],
      priceNote: '11,99 €/mois après l\'essai',
      cta: 'Essayer 5 jours gratuitement',
    },
    cloud: {
      badge: 'En développement — bêta privée',
      name: 'White Bot Cloud',
      desc: 'Nous exécutons le bot pour vous sur nos serveurs, 24/7, sans rien installer. Actuellement en bêta privée pendant que nous le finalisons.',
      features: [
        'Exécuté par nous, 24/7',
        'Zéro installation — pas de PC nécessaire',
        'Intelligence complète et illimitée',
        'Places limitées',
      ],
      priceNote: 'Dès 49,99 €/mois à l\'ouverture',
      notifyLabel: 'Intéressé ? Nous vous écrivons à l\'ouverture :',
      betaAccess: 'Déjà dans la bêta privée ? Se connecter',
    },
  },
  cloudNotify: {
    emailPh: 'vous@email.com',
    submit: 'Prévenez-moi à l\'ouverture',
    submitting: 'Envoi en cours…',
    successTitle: 'C\'est noté !',
    successBody: 'Nous écrirons à cet email quand White Bot Cloud ouvrira ses portes.',
    errorMsg: 'Envoi impossible. Réessayez dans un instant.',
  },
  forwhom: {
    yes: {
      title: 'Parfait pour vous si…',
      items: [
        'Vous avez déjà un compte établi sur Whiteout Survival',
        'Vous avez un PC Windows où le bot peut tourner',
        'Vous voulez progresser pendant que vous travaillez, étudiez ou dormez',
        'Vous voulez contrôler le bot depuis votre téléphone, n\'importe où',
      ],
    },
    no: {
      title: 'À noter…',
      items: [
        'Le bot a besoin de votre PC allumé, avec BlueStacks ouvert, pendant qu\'il travaille',
        'White Bot ne gère pas les tutoriels ni les nouveaux comptes',
        'Les bots peuvent enfreindre les CGU du jeu (voir FAQ)',
        'Le jeu doit être en anglais ou en espagnol',
      ],
    },
  },
  compare: {
    title: 'Manuel vs White Bot',
    sub: 'Les mêmes actions que vous feriez — mais 24 heures sur 24.',
    headers: ['', 'En jouant manuellement', 'Avec White Bot'],
    rows: [
      ['Heures actives', 'Seulement quand vous jouez', '24 h / 7 jours'],
      ['Collecte de ressources', 'Limitée à vos sessions', 'Continue et maximisée'],
      ['File de troupes', 'Parfois oubliée vide', 'Toujours active'],
      ['Chasse de monstres', 'Quelques-uns par jour', 'Des dizaines de cycles par jour'],
      ['Votre temps investi', '2–3 heures par jour', '0 heure'],
      ['Contrôle mobile', 'Seulement l\'appli du jeu', 'Panneau complet dans le navigateur'],
    ],
  },
  benefits: {
    title: 'Tout ce qu\'il fait pour vous',
    sub: 'Des actions réelles dans le jeu, automatisées sur votre propre PC.',
    items: [
      { title: 'Collecte automatique', desc: 'Collecte les ressources sur la carte sans que vous ayez à ouvrir le jeu.' },
      { title: 'Entraînement de troupes', desc: 'Maintient les files d\'entraînement toujours actives pour maximiser votre progression.' },
      { title: 'Auto Hunt', desc: 'Chasse les monstres en continu pour accumuler des objets précieux.' },
      { title: 'Auto Bouclier', desc: 'Surveille les attaques entrantes : il lâche tout, active un bouclier de votre sac et rappelle vos marches, restant en mode protégé.' },
      { title: 'Intelligence', desc: '5 recherches par jour : puissance, coordonnées et dernière connexion de tout joueur ou alliance, depuis le réseau White Bot.' },
      { title: 'Panneau de contrôle web', desc: 'Configurez, mettez en pause et surveillez votre bot depuis n\'importe quel navigateur, mobile inclus.' },
    ],
  },
  steps: {
    title: 'Comment ça marche',
    sub: 'Du téléchargement au bot actif en quelques minutes.',
    items: [
      { title: 'Créez votre compte et lancez votre essai', desc: 'Inscrivez-vous sur le site du produit et démarrez vos 5 jours gratuits.' },
      { title: 'Téléchargez et installez le client', desc: 'Windows + BlueStacks. Le guide d\'installation vous accompagne pas à pas.' },
      { title: 'Activez avec votre email', desc: 'Saisissez votre email et le code d\'activation dans le client. Voilà : client connecté.' },
      { title: 'Contrôlez tout depuis le web', desc: 'Configurez les actions, mettez en pause ou surveillez depuis n\'importe quel appareil. Le bot travaille sur votre PC.' },
    ],
  },
  pricing: {
    title: 'Tarifs',
    sub: 'Sans engagement. Annulez quand vous voulez.',
    downloadable: {
      name: 'White Bot Desktop', badge: 'Disponible maintenant', price: '11,99 €', period: '/mois',
      desc: '5 jours d\'essai gratuit, sans carte. Ensuite, un seul plan tout compris.',
      features: ['Collecte, entraînement des troupes, chasse et Auto Bouclier', 'Contrôle depuis le web', '🔍 Intelligence : 5 recherches/jour', 'Mises à jour et support inclus'],
      cta: 'Essayer 5 jours gratuitement',
    },
    cloud: {
      name: 'White Bot Cloud', badge: 'En développement', price: 'dès 49,99 €', period: '/mois',
      desc: 'Bêta privée. Nous exécutons le bot pour vous, avec des fonctions exclusives.',
      features: ['Exécution 24/7 sur nos serveurs', 'Zéro installation', 'Intelligence complète et illimitée', 'Places limitées'],
      cta: 'Prévenez-moi à l\'ouverture',
    },
    betaBadge: 'Bêta · bientôt',
    soon: 'Bientôt',
    farm: { name: 'Ferme', price: '21,99 €', period: '/mois', tagline: 'Jusqu\'à 3 comptes à la fois' },
    farmPlus: { name: 'Ferme+', price: '49,99 €', period: '/mois', tagline: 'Jusqu\'à 10 comptes à la fois' },
  },
  trust: {
    title: 'Sécurité & confidentialité',
    sub: 'Conçu pour que vous gardiez toujours le contrôle.',
    items: [
      { title: 'Aucun mot de passe partagé', desc: 'Vous liez votre compte de jeu vous-même, dans votre propre BlueStacks. Vos identifiants ne quittent jamais votre PC.' },
      { title: 'Votre PC, votre contrôle', desc: 'Le bot tourne sur votre machine et ne communique avec nos serveurs que pour valider votre licence et alimenter votre panneau.' },
      { title: 'Sans engagement', desc: 'Annulez quand vous voulez depuis le web. L\'accès reste actif jusqu\'à la fin de la période payée.' },
      { title: 'Paiements sécurisés avec Stripe', desc: 'Le paiement est traité par Stripe. Vos données de carte ne transitent jamais par nos serveurs.' },
    ],
  },
  risk: {
    title: 'Transparence sur le risque',
    p1: 'White Bot automatise des actions dans le jeu via un émulateur qui tourne sur votre propre PC. L\'utilisation de logiciels tiers peut enfreindre les <strong>Conditions d\'utilisation de Whiteout Survival</strong> et peut entraîner des sanctions de la part du développeur, incluant restriction ou suspension du compte. Le risque pèse sur votre compte et votre machine.',
    p2: 'Le bot est programmé pour imiter le comportement humain : délais d\'action variables, pauses naturelles et cycles réalistes. <strong>À ce jour, aucun ban confirmé n\'a été signalé parmi nos utilisateurs.</strong> Le risque existe et l\'utilisateur l\'accepte en utilisant le produit. Consultez nos <a href="/terms">Conditions d\'utilisation</a>.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Une question ?',
    sub: 'Écrivez-nous et nous vous répondrons sous 24 heures.',
    label: 'Ou contactez-nous directement :',
    fields: { name: 'Nom', email: 'Email', subject: 'Sujet', message: 'Message' },
    subjects: { consulta: 'Question générale', soporte: 'Support technique', facturacion: 'Facturation / abonnement', baneo: 'Signalement d\'incident', otro: 'Autre' },
    submit: 'Envoyer le message', submitting: 'Envoi en cours…',
    successTitle: 'Message envoyé !', successBody: 'Nous vous répondrons sous 24 heures.',
    errorMsg: 'Erreur lors de l\'envoi. Réessayez ou écrivez à whitebot.admin@gmail.com',
    namePh: 'Votre nom', emailPh: 'vous@email.com', messagePh: 'Décrivez votre question…',
  },
  vs: {
    title: 'Pas une ferme cloud de plus',
    sub: 'La plupart des bots Whiteout vendent du volume : serveurs cloud, comptes illimités, « ressources x100 ». White Bot est conçu pour un seul compte — le vôtre.',
    them: {
      title: 'Bots cloud',
      items: [
        'Votre identifiant vit sur le serveur de quelqu\'un d\'autre',
        'Conçus pour des centaines de fermes jetables',
        'Vendent de l\'« indétectable » — une promesse que personne ne peut tenir',
        'Si leur serveur tombe, votre bot aussi',
      ],
    },
    us: {
      title: 'White Bot',
      items: [
        'Tourne sur votre PC — votre identifiant ne quitte jamais votre machine',
        'Conçu pour faire grandir et défendre le compte qui compte',
        'Honnête sur le risque — jeu humain, pas de promesses magiques',
        'Auto Bouclier : détecte les attaques, active un bouclier, rappelle vos troupes',
      ],
    },
    cta: 'Protégez votre ville — essai gratuit',
  },
  betaList: {
    title: 'Ne manquez pas la bêta gratuite',
    body: 'Le bot complet est gratuit jusqu\'au 15 août 2026 — les offres payantes commencent le 16 août. Laissez votre email et nous vous préviendrons avant la fin.',
    emailPh: 'vous@email.com',
    submit: 'Prévenez-moi',
    submitting: 'Envoi…',
    successTitle: 'C\'est fait !',
    successBody: 'Nous vous écrirons avant la fin de la bêta gratuite.',
    errorMsg: 'Envoi impossible. Réessayez dans un instant.',
    supportNote: 'Des questions ? Écrivez-nous via le chat du support de l\'app — on répond vite.',
  },
  beta: {
    hero: { badge: 'Bêta gratuite jusqu\'au 15 août · Sans engagement', cta1: 'Rejoindre la bêta gratuite' },
    stats: { s4v: 'Gratuit', s4l: 'Bêta jusqu\'au 15 août 2026, sans carte' },
    stepTrial: {
      title: 'Créez votre compte et rejoignez la bêta',
      desc: 'Inscrivez-vous sur le site du produit — gratuit pendant la bêta, sans carte.',
    },
    downloadable: {
      badge: 'Bêta gratuite',
      trialFeature: 'Bêta gratuite jusqu\'au 15 août 2026 — sans carte',
      priceNote: 'Gratuit jusqu\'au 15 août 2026 — ensuite 11,99 €/mois',
      cta: 'Rejoindre la bêta gratuite',
    },
    faq: {
      q: 'Que comprend la bêta gratuite ?',
      a: 'Jusqu\'au 15 août 2026, White Bot Desktop est entièrement gratuit : créez votre compte, commencez la bêta (sans carte) et utilisez le bot complet. Le 16 août, le modèle normal s\'applique — essai de 5 jours pour les nouveaux utilisateurs et abonnement à 11,99 €/mois. Nous préviendrons les utilisateurs de la bêta par email avant la fin.',
    },
  },
  faq: {
    title: 'Questions fréquentes',
    items: [
      { q: 'De quoi ai-je besoin pour utiliser White Bot ?', a: 'Un PC Windows, l\'émulateur gratuit BlueStacks et votre compte Whiteout Survival. Le bot s\'installe sur votre PC et se contrôle depuis le web, depuis n\'importe quel appareil.' },
      { q: 'Dois-je installer quelque chose ?', a: 'Oui. Contrairement aux bots cloud, White Bot tourne sur votre propre PC : vous installez le client et BlueStacks en suivant le guide pas à pas. Le contrôle au quotidien est 100 % web — sans toucher au PC.' },
      { q: 'Le bot fonctionne-t-il PC éteint ?', a: 'Non. Le bot tourne sur votre PC, il a donc besoin de la machine allumée avec BlueStacks ouvert. Vous pouvez fermer le navigateur et contrôler le bot à distance à tout moment ; ce qu\'il ne peut pas faire, c\'est travailler machine éteinte.' },
      { q: 'Fonctionne-t-il avec de nouveaux comptes ?', a: 'Non. White Bot est conçu pour les joueurs avec des comptes déjà établis. Le système ne gère pas les tutoriels de démarrage ni la création de compte. Vous devez avoir votre compte configuré et prêt à jouer avant d\'utiliser le bot.' },
      { q: 'Puis-je être banni pour utiliser White Bot ?', a: 'Oui, un risque inhérent existe. L\'utilisation de logiciels d\'automatisation peut enfreindre les CGU de Whiteout Survival. White Bot imite le comportement humain : délais aléatoires, pauses naturelles et cycles réalistes. À ce jour, aucun ban confirmé parmi nos utilisateurs. Le bot tourne sur votre PC avec votre compte : le risque est le vôtre et vous l\'acceptez expressément (voir Conditions d\'utilisation).' },
      { q: 'Que se passe-t-il si je suis banni ?', a: 'White Bot fournit le logiciel d\'automatisation ; il ne garantit pas les résultats dans le jeu ni la sécurité du compte face au développeur. Si une sanction survient, nous évaluons chaque cas individuellement. Un ban causé par une erreur technique de notre part sera étudié pour un remboursement proportionnel. Les sanctions pour risque inhérent accepté dans les CGU ne génèrent pas de remboursement automatique.' },
      { q: 'Comment lier mon compte de jeu ?', a: 'Vous le faites vous-même : vous vous connectez à votre compte dans BlueStacks exactement comme sur votre téléphone. Nous ne voyons ni ne stockons jamais vos identifiants — ils ne quittent pas votre PC.' },
      { q: 'Que comprend l\'essai de 5 jours ?', a: '5 jours avec le bot COMPLET, sans carte. Créez votre compte, cliquez sur « Commencer l\'essai gratuit » et téléchargez le client : aucune donnée de paiement demandée. À la fin de l\'essai, le bot s\'arrête ; s\'il vous convainc, abonnez-vous pour 11,99 €/mois et reprenez là où vous en étiez (votre configuration est conservée). Un essai par compte et par PC.' },
      { q: 'Comment fonctionne Auto Bouclier ?', a: 'Pendant que le bot travaille, il surveille les attaques entrantes. S\'il en confirme une, il arrête tout, active un bouclier de votre sac, rappelle vos marches et reste en mode protégé jusqu\'à ce que vous repreniez. Remarque : il utilise les boucliers que vous possédez déjà dans votre sac (il ne les achète pas) et ce n\'est pas une garantie absolue contre les attaques éclair.' },
      { q: 'Dans quelle langue le jeu doit-il être ?', a: 'En anglais ou en espagnol. Vous pouvez changer la langue configurée depuis le web à tout moment.' },
      { q: 'Puis-je mettre en pause ou arrêter le bot à tout moment ?', a: 'Oui. Depuis le panneau web, vous pouvez arrêter, mettre en pause ou reconfigurer le bot immédiatement, depuis n\'importe quel appareil.' },
      { q: 'Comment résilier mon abonnement ?', a: 'Vous pouvez résilier à tout moment depuis le web. L\'accès reste actif jusqu\'à la fin de la période de facturation en cours. Sans engagement, sans pénalité.' },
      { q: 'Qu\'est-ce que White Bot Cloud ?', a: 'C\'est la version hébergée : le bot tourne sur nos serveurs 24/7, sans installation et avec l\'Intelligence régionale complète et illimitée (le Desktop inclut 5 recherches par jour). Elle est en développement, en bêta privée. À l\'ouverture, ce sera une offre premium (dès 49,99 €/mois). Laissez votre email dans la section produits et nous vous préviendrons.' },
    ],
  },
  blog: {
    sectionTitle: 'Guides et stratégies',
    sectionSub: 'Apprenez à progresser plus vite dans Whiteout Survival.',
    readMore: 'Lire le guide →',
    viewAll: 'Voir tous les guides',
  },
  footer: {
    copy: '© 2026 White Bot · Non affilié à Whiteout Survival ou Century Games',
    links: { enter: 'Connexion', faq: 'FAQ', contact: 'Contact', privacy: 'Politique de confidentialité', terms: 'Conditions d\'utilisation', blog: 'Blog', status: 'Statut' },
  },
  referral: {
    title: 'Invitez des amis, gagnez des jours gratuits',
    body: 'Partagez votre code personnel et <strong>votre ami obtient 8 jours d\'essai</strong> (3 de plus). Quand il devient client payant, vous cumulez <strong>+15 jours gratuits</strong>. Votre code sera disponible dans votre panneau une fois actif.',
    stat1: '+3 jours pour votre ami',
    stat2: '+15 jours pour vous par conversion',
  },
  waitlist: {
    badge: 'Aucune place disponible pour le moment',
    title: 'Rejoindre la liste d\'attente',
    body: 'Chaque place White Bot est du matériel dédié, nous ouvrons donc l\'accès par vagues. Laissez votre email et nous vous inviterons automatiquement dès qu\'une place se libère.',
    emailPh: 'votre@email.com',
    submit: 'Rejoindre la liste',
    submitting: 'Ajout en cours…',
    successTitle: 'Vous êtes sur la liste',
    successBody: 'Vous êtes #{position} sur {total}. Nous vous enverrons une invitation par email dès qu\'une place se libère — inutile de revenir vérifier.',
    invitedTitle: 'Votre invitation arrive',
    invitedBody: 'Une place s\'est libérée pour vous. Consultez votre boîte mail pour activer votre compte avec l\'invitation.',
    claimedTitle: 'Vous avez déjà accès',
    claimedBody: 'Cet email a déjà un compte. Utilisez le bouton de connexion pour accéder à votre tableau de bord.',
    errorMsg: 'Une erreur est survenue. Réessayez dans un instant.',
    invalidEmail: 'Saisissez une adresse email valide.',
    haveInvite: 'Déjà invité ? Se connecter',
    ctaJoin: 'Rejoindre la liste',
    waitingCount: '{count} joueurs déjà en attente',
  },
};

const de: Translations = {
  nav: { products: 'Produkte', how: 'So funktioniert\'s', pricing: 'Preise', faq: 'FAQ', contact: 'Kontakt', enter: 'Anmelden' },
  hero: {
    badge: '5 Tage kostenlos testen · Keine Bindung',
    tagline: [
      'Der Whiteout-Survival-Bot, der deine Stadt schützt, während du schläfst —',
      'Auto-Schild erkennt Angriffe, aktiviert den Schild und ruft deine Truppen zurück.',
      'Läuft auf deinem eigenen PC. Gesteuert vom Handy.',
    ],
    cta1: '5 Tage kostenlos testen',
    cta2: 'So funktioniert\'s ↓',
  },
  stats: {
    s1v: '24/7', s1l: 'Bot arbeitet auf deinem PC',
    s2v: '100% Web', s2l: 'Steuerung von jedem Gerät',
    s3v: '0 bestätigte Bans', s3l: 'Unter unseren Nutzern',
    s4v: '5 Tage', s4l: 'Kostenlos testen, jederzeit kündbar',
  },
  products: {
    title: 'Wähle deinen White Bot',
    sub: 'Derselbe Bot, zwei Arten ihn auszuführen.',
    downloadable: {
      badge: 'Jetzt verfügbar',
      name: 'White Bot Desktop',
      desc: 'Der Bot läuft auf deinem PC mit Windows und BlueStacks. Du installierst ihn, er gehört dir — und du steuerst alles über das Web, egal wo du bist.',
      features: [
        'Läuft auf deinem PC (Windows + BlueStacks)',
        'Volle Kontrolle über das Web',
        'Sammeln, Truppentraining, Jagd und Auto-Schild',
        '🔍 Intelligence: 5 Abfragen/Tag inklusive',
        '5 Tage kostenlos testen — ohne Karte',
      ],
      priceNote: '11,99 €/Monat nach der Testphase',
      cta: '5 Tage kostenlos testen',
    },
    cloud: {
      badge: 'In Entwicklung — private Beta',
      name: 'White Bot Cloud',
      desc: 'Wir führen den Bot für dich auf unseren Servern aus, 24/7, ohne dass du etwas installierst. Derzeit in privater Beta, während wir ihn fertigstellen.',
      features: [
        'Von uns betrieben, 24/7',
        'Null Installation — kein PC nötig',
        'Vollständige, unbegrenzte Intelligence',
        'Begrenzte Plätze',
      ],
      priceNote: 'Ab 49,99 €/Monat zur Eröffnung',
      notifyLabel: 'Interessiert? Wir schreiben dir zur Eröffnung:',
      betaAccess: 'Schon in der privaten Beta? Anmelden',
    },
  },
  cloudNotify: {
    emailPh: 'du@email.com',
    submit: 'Benachrichtigt mich',
    submitting: 'Wird gesendet…',
    successTitle: 'Notiert!',
    successBody: 'Wir schreiben an diese E-Mail, sobald White Bot Cloud seine Türen öffnet.',
    errorMsg: 'Senden fehlgeschlagen. Bitte versuche es gleich noch einmal.',
  },
  forwhom: {
    yes: {
      title: 'Perfekt für dich, wenn…',
      items: [
        'Du bereits einen etablierten Whiteout-Survival-Account hast',
        'Du einen Windows-PC hast, auf dem der Bot laufen kann',
        'Du Fortschritte machen willst, während du arbeitest, lernst oder schläfst',
        'Du den Bot vom Handy aus steuern willst, egal wo',
      ],
    },
    no: {
      title: 'Beachte…',
      items: [
        'Der Bot braucht deinen eingeschalteten PC mit laufendem BlueStacks, während er arbeitet',
        'White Bot übernimmt keine Tutorials und keine neuen Accounts',
        'Bots können gegen die Nutzungsbedingungen des Spiels verstoßen (siehe FAQ)',
        'Das Spiel muss auf Englisch oder Spanisch eingestellt sein',
      ],
    },
  },
  compare: {
    title: 'Manuell vs White Bot',
    sub: 'Dieselben Aktionen, die du selbst machen würdest — aber 24 Stunden am Tag.',
    headers: ['', 'Manuell spielen', 'Mit White Bot'],
    rows: [
      ['Aktive Stunden', 'Nur wenn du spielst', '24 h / 7 Tage'],
      ['Ressourcen sammeln', 'Auf deine Sitzungen begrenzt', 'Kontinuierlich und maximiert'],
      ['Truppen-Warteschlange', 'Manchmal leer vergessen', 'Immer aktiv'],
      ['Monsterjagd', 'Wenige pro Tag', 'Dutzende Zyklen am Tag'],
      ['Deine investierte Zeit', '2–3 Stunden täglich', '0 Stunden'],
      ['Mobile Steuerung', 'Nur die Spiele-App', 'Volles Panel in jedem Browser'],
    ],
  },
  benefits: {
    title: 'Alles, was er für dich erledigt',
    sub: 'Echte Spielaktionen, automatisiert auf deinem eigenen PC.',
    items: [
      { title: 'Automatisches Sammeln', desc: 'Sammelt Ressourcen auf der Karte, ohne dass du das Spiel öffnen musst.' },
      { title: 'Truppentraining', desc: 'Hält die Trainingswarteschlangen immer aktiv, um deinen Fortschritt zu maximieren.' },
      { title: 'Auto Hunt', desc: 'Jagt kontinuierlich Monster, um wertvolle Gegenstände anzusammeln.' },
      { title: 'Auto-Schild', desc: 'Überwacht eingehende Angriffe: lässt alles stehen, aktiviert ein Schild aus deinem Rucksack und ruft deine Truppen zurück, im Schutzmodus.' },
      { title: 'Intelligence', desc: '5 Abfragen pro Tag: Macht, Koordinaten und zuletzt gesehen von jedem Spieler oder jeder Allianz, aus dem White-Bot-Netzwerk.' },
      { title: 'Web-Kontrollpanel', desc: 'Konfiguriere, pausiere und überwache deinen Bot von jedem Browser aus, auch mobil.' },
    ],
  },
  steps: {
    title: 'So funktioniert\'s',
    sub: 'Vom Download zum aktiven Bot in wenigen Minuten.',
    items: [
      { title: 'Konto erstellen und Test starten', desc: 'Registriere dich auf der Produktseite und starte deine 5 kostenlosen Tage.' },
      { title: 'Client herunterladen und installieren', desc: 'Windows + BlueStacks. Die Installationsanleitung begleitet dich Schritt für Schritt.' },
      { title: 'Mit deiner E-Mail aktivieren', desc: 'Gib deine E-Mail und den Aktivierungscode im Client ein. Fertig: Client verbunden.' },
      { title: 'Alles über das Web steuern', desc: 'Konfiguriere Aktionen, pausiere oder überwache von jedem Gerät. Der Bot arbeitet auf deinem PC.' },
    ],
  },
  pricing: {
    title: 'Preise',
    sub: 'Keine Bindung. Jederzeit kündbar.',
    downloadable: {
      name: 'White Bot Desktop', badge: 'Jetzt verfügbar', price: '11,99 €', period: '/Monat',
      desc: '5 Tage kostenlos testen, ohne Karte. Danach ein einziger Plan mit allem inklusive.',
      features: ['Sammeln, Truppentraining, Jagd und Auto-Schild', 'Steuerung über das Web', '🔍 Intelligence: 5 Abfragen/Tag', 'Updates und Support inklusive'],
      cta: '5 Tage kostenlos testen',
    },
    cloud: {
      name: 'White Bot Cloud', badge: 'In Entwicklung', price: 'ab 49,99 €', period: '/Monat',
      desc: 'Private Beta. Wir betreiben den Bot für dich, mit exklusiven Funktionen.',
      features: ['Läuft 24/7 auf unseren Servern', 'Null Installation', 'Vollständige, unbegrenzte Intelligence', 'Begrenzte Plätze'],
      cta: 'Benachrichtigt mich',
    },
    betaBadge: 'Beta · bald',
    soon: 'Bald verfügbar',
    farm: { name: 'Farm', price: '21,99 €', period: '/Monat', tagline: 'Bis zu 3 Konten gleichzeitig' },
    farmPlus: { name: 'Farm+', price: '49,99 €', period: '/Monat', tagline: 'Bis zu 10 Konten gleichzeitig' },
  },
  trust: {
    title: 'Sicherheit & Datenschutz',
    sub: 'So gestaltet, dass du immer die Kontrolle behältst.',
    items: [
      { title: 'Keine geteilten Passwörter', desc: 'Du verknüpfst deinen Spiel-Account selbst, in deinem eigenen BlueStacks. Deine Zugangsdaten verlassen nie deinen PC.' },
      { title: 'Dein PC, deine Kontrolle', desc: 'Der Bot läuft auf deiner Maschine und kommuniziert mit unseren Servern nur, um deine Lizenz zu prüfen und dein Panel zu versorgen.' },
      { title: 'Keine Bindung', desc: 'Kündige jederzeit über das Web. Der Zugang bleibt bis zum Ende des bezahlten Zeitraums aktiv.' },
      { title: 'Sichere Zahlungen mit Stripe', desc: 'Die Zahlung wird von Stripe abgewickelt. Deine Kartendaten berühren nie unsere Server.' },
    ],
  },
  risk: {
    title: 'Transparenz über das Risiko',
    p1: 'White Bot automatisiert Spielaktionen in einem Emulator, der auf deinem eigenen PC läuft. Die Nutzung von Drittanbieter-Software kann gegen die <strong>Nutzungsbedingungen von Whiteout Survival</strong> verstoßen und zu Sanktionen durch den Spieleentwickler führen, einschließlich Einschränkung oder Sperrung des Accounts. Das Risiko liegt bei deinem Account und deiner Maschine.',
    p2: 'Der Bot ist so programmiert, dass er sich wie ein menschlicher Spieler verhält: variable Aktionszeiten, natürliche Pausen und realistische Zyklen. <strong>Bis heute gibt es keinen bestätigten Ban unter unseren Nutzern.</strong> Das Risiko besteht dennoch und der Nutzer akzeptiert es mit der Nutzung des Produkts. Siehe unsere <a href="/terms">Nutzungsbedingungen</a>.',
    termsLink: '/terms',
  },
  contact: {
    title: 'Hast du eine Frage?',
    sub: 'Schreib uns und wir antworten innerhalb von 24 Stunden.',
    label: 'Oder schreib uns direkt:',
    fields: { name: 'Name', email: 'E-Mail', subject: 'Betreff', message: 'Nachricht' },
    subjects: { consulta: 'Allgemeine Anfrage', soporte: 'Technischer Support', facturacion: 'Abrechnung / Abo', baneo: 'Vorfall melden', otro: 'Sonstiges' },
    submit: 'Nachricht senden', submitting: 'Wird gesendet…',
    successTitle: 'Nachricht gesendet!', successBody: 'Wir melden uns innerhalb von 24 Stunden.',
    errorMsg: 'Fehler beim Senden. Versuche es erneut oder schreib an whitebot.admin@gmail.com',
    namePh: 'Dein Name', emailPh: 'du@email.com', messagePh: 'Erzähl uns dein Anliegen…',
  },
  vs: {
    title: 'Keine weitere Cloud-Farm',
    sub: 'Die meisten Whiteout-Bots verkaufen Masse: Cloud-Server, unbegrenzte Konten, „x100 Ressourcen". White Bot ist für ein Konto gebaut — deins.',
    them: {
      title: 'Cloud-Bots',
      items: [
        'Dein Login liegt auf dem Server von jemand anderem',
        'Gebaut für hunderte Wegwerf-Farmen',
        'Verkaufen „undetectable" — ein Versprechen, das niemand halten kann',
        'Fällt deren Server aus, fällt auch dein Bot aus',
      ],
    },
    us: {
      title: 'White Bot',
      items: [
        'Läuft auf deinem PC — dein Login verlässt nie deine Maschine',
        'Gebaut, um das Konto zu schützen, das zählt',
        'Ehrlich beim Risiko — menschliches Spielverhalten, keine Wunderversprechen',
        'Auto-Schild: erkennt Angriffe, aktiviert den Schild, ruft Truppen zurück',
      ],
    },
    cta: 'Schütze deine Stadt — kostenlos testen',
  },
  betaList: {
    title: 'Verpass die kostenlose Beta nicht',
    body: 'Der volle Bot ist bis zum 15. August 2026 kostenlos — bezahlte Pläne starten am 16. August. Lass deine E-Mail da und wir erinnern dich vor dem Ende.',
    emailPh: 'du@email.com',
    submit: 'Sag mir Bescheid',
    submitting: 'Senden…',
    successTitle: 'Erledigt!',
    successBody: 'Wir schreiben dir, bevor die kostenlose Beta endet.',
    errorMsg: 'Senden fehlgeschlagen. Versuch es gleich noch einmal.',
    supportNote: 'Fragen? Schreib uns im Support-Chat der App — wir antworten schnell.',
  },
  beta: {
    hero: { badge: 'Kostenlose Beta bis zum 15. August · Keine Bindung', cta1: 'Kostenlose Beta starten' },
    stats: { s4v: 'Kostenlos', s4l: 'Beta bis 15. Aug 2026, ohne Karte' },
    stepTrial: {
      title: 'Konto erstellen und der Beta beitreten',
      desc: 'Registriere dich auf der Produktseite — kostenlos während der Beta, ohne Karte.',
    },
    downloadable: {
      badge: 'Kostenlose Beta',
      trialFeature: 'Kostenlose Beta bis zum 15. August 2026 — ohne Karte',
      priceNote: 'Kostenlos bis zum 15. August 2026 — danach 11,99 €/Monat',
      cta: 'Kostenlose Beta starten',
    },
    faq: {
      q: 'Was beinhaltet die kostenlose Beta?',
      a: 'Bis zum 15. August 2026 ist White Bot Desktop komplett kostenlos: Konto erstellen, Beta starten (ohne Karte) und den vollen Bot nutzen. Ab dem 16. August gilt das normale Modell — 5-Tage-Test für neue Nutzer und Abo für 11,99 €/Monat. Beta-Nutzer erhalten vor dem Ende eine E-Mail von uns.',
    },
  },
  faq: {
    title: 'Häufige Fragen',
    items: [
      { q: 'Was brauche ich, um White Bot zu nutzen?', a: 'Einen Windows-PC, den kostenlosen BlueStacks-Emulator und deinen Whiteout-Survival-Account. Der Bot wird auf deinem PC installiert und über das Web gesteuert, von jedem Gerät aus.' },
      { q: 'Muss ich etwas installieren?', a: 'Ja. Anders als Cloud-Bots läuft White Bot auf deinem eigenen PC: Du installierst den Client und BlueStacks mit der Schritt-für-Schritt-Anleitung. Die tägliche Steuerung ist 100 % webbasiert — ohne den PC anzufassen.' },
      { q: 'Funktioniert der Bot bei ausgeschaltetem PC?', a: 'Nein. Der Bot läuft auf deinem PC und braucht die eingeschaltete Maschine mit geöffnetem BlueStacks. Du kannst den Browser schließen und den Bot jederzeit aus der Ferne steuern; was er nicht kann, ist bei ausgeschalteter Maschine zu arbeiten.' },
      { q: 'Funktioniert er mit neuen Accounts?', a: 'Nein. White Bot ist für Spieler mit etablierten Accounts konzipiert. Das System übernimmt keine Start-Tutorials und keine Account-Erstellung. Dein Account muss eingerichtet und spielbereit sein, bevor du den Bot nutzt.' },
      { q: 'Kann ich für die Nutzung von White Bot gebannt werden?', a: 'Ja, es besteht ein inhärentes Risiko. Die Nutzung von Automatisierungssoftware kann gegen die Nutzungsbedingungen von Whiteout Survival verstoßen. White Bot imitiert menschliches Spielverhalten: zufällige Aktionszeiten, natürliche Pausen und realistische Zyklen. Bis heute gibt es keinen bestätigten Ban unter unseren Nutzern. Der Bot läuft auf deinem PC mit deinem Account: Das Risiko liegt bei dir und du akzeptierst es ausdrücklich (siehe Nutzungsbedingungen).' },
      { q: 'Was passiert, wenn ich gebannt werde?', a: 'White Bot stellt die Automatisierungssoftware bereit; es garantiert weder Spielergebnisse noch die Sicherheit des Accounts gegenüber dem Entwickler. Bei einer Sanktion prüfen wir jeden Fall einzeln. Ein Ban, der eindeutig auf einen technischen Fehler unsererseits zurückgeht, wird für eine anteilige Erstattung geprüft. Sanktionen aus dem in den Nutzungsbedingungen akzeptierten inhärenten Risiko führen nicht zu einer automatischen Erstattung.' },
      { q: 'Wie verknüpfe ich meinen Spiel-Account?', a: 'Das machst du selbst: Du meldest dich in BlueStacks bei deinem Account an, genau wie auf deinem Handy. Wir sehen und speichern deine Zugangsdaten nie — sie verlassen deinen PC nicht.' },
      { q: 'Was beinhaltet die 5-tägige Testphase?', a: '5 Tage mit dem KOMPLETTEN Bot, ohne Karte. Konto erstellen, auf „Kostenlose Testphase starten" klicken und den Client herunterladen — wir fragen keine Zahlungsdaten ab. Nach der Testphase stoppt der Bot; wenn er dich überzeugt, abonnierst du für 11,99 €/Monat und machst genau dort weiter (deine Einstellungen bleiben erhalten). Eine Testphase pro Konto und pro PC.' },
      { q: 'Wie funktioniert Auto-Schild?', a: 'Während der Bot arbeitet, überwacht er eingehende Angriffe. Bestätigt er einen, stoppt er alles, aktiviert ein Schild aus deinem Rucksack, ruft deine Truppen zurück und bleibt im Schutzmodus, bis du fortsetzt. Hinweis: Er nutzt Schilde, die du bereits im Rucksack hast (er kauft sie nicht), und ist keine absolute Garantie gegen Blitzangriffe.' },
      { q: 'In welcher Sprache muss das Spiel sein?', a: 'Auf Englisch oder Spanisch. Du kannst die eingestellte Spielsprache jederzeit über das Web ändern.' },
      { q: 'Kann ich den Bot jederzeit pausieren oder stoppen?', a: 'Ja. Über das Web-Panel kannst du den Bot sofort stoppen, pausieren oder neu konfigurieren, von jedem Gerät aus.' },
      { q: 'Wie kündige ich mein Abo?', a: 'Du kannst jederzeit über das Web kündigen. Der Zugang bleibt bis zum Ende des laufenden Abrechnungszeitraums aktiv. Keine Bindung, keine Strafe.' },
      { q: 'Was ist White Bot Cloud?', a: 'Das ist die gehostete Version: Der Bot läuft 24/7 auf unseren Servern, ohne Installation und mit vollständiger, unbegrenzter regionaler Intelligence (Desktop enthält 5 Abfragen pro Tag). Sie ist in Entwicklung, in privater Beta. Zur Eröffnung wird sie ein Premium-Angebot sein (ab 49,99 €/Monat). Hinterlasse deine E-Mail im Produktbereich und wir benachrichtigen dich.' },
    ],
  },
  blog: {
    sectionTitle: 'Guides & Strategien',
    sectionSub: 'Lerne, wie du in Whiteout Survival schneller wächst.',
    readMore: 'Guide lesen →',
    viewAll: 'Alle Guides ansehen',
  },
  footer: {
    copy: '© 2026 White Bot · Nicht mit Whiteout Survival oder Century Games verbunden',
    links: { enter: 'Anmelden', faq: 'FAQ', contact: 'Kontakt', privacy: 'Datenschutzerklärung', terms: 'Nutzungsbedingungen', blog: 'Blog', status: 'Status' },
  },
};

export const translations: Record<Lang, Translations> = { en, es, pt, fr, de, ru, ko, zh, ja, tr };

export const LANG_LABELS: Record<Lang, string> = {
  en: '🇬🇧 EN',
  es: '🇪🇸 ES',
  pt: '🇧🇷 PT',
  fr: '🇫🇷 FR',
  de: '🇩🇪 DE',
  ru: '🇷🇺 RU',
  ko: '🇰🇷 KO',
  zh: '🇹🇼 中文',
  ja: '🇯🇵 JA',
  tr: '🇹🇷 TR',
};

export function detectLang(): Lang {
  // El prefijo de ruta gana (URLs por idioma /es/, /ru/…: elección explícita)
  const fromPath = location.pathname.match(/^\/(es|pt|fr|de|ru|ko|zh|ja|tr)(\/|$)/);
  if (fromPath) return fromPath[1] as Lang;
  const stored = localStorage.getItem('wb_lang') as Lang | null;
  if (stored && stored in translations) return stored;
  const browser = (navigator.language || 'en').toLowerCase();
  if (browser.startsWith('es')) return 'es';
  if (browser.startsWith('pt')) return 'pt';
  if (browser.startsWith('fr')) return 'fr';
  if (browser.startsWith('de')) return 'de';
  if (browser.startsWith('ru')) return 'ru';
  if (browser.startsWith('ko')) return 'ko';
  if (browser.startsWith('zh')) return 'zh';
  if (browser.startsWith('ja')) return 'ja';
  if (browser.startsWith('tr')) return 'tr';
  return 'en';
}
